import { UAParser } from 'ua-parser-js'

const uaInfo = UAParser()

export default uaInfo